import { useContext } from "react";
import { FlashMessengerContext } from "../../uikit/components/FlashMessenger/FlashMessengerProvider";

export default function useFlashMessenger() {
    const { setSuccessMessage, setErrorMessage, message, removeMessage } = useContext(FlashMessengerContext);

    return { setErrorMessage, setSuccessMessage, message, removeMessage };
}
